export function preFetchIcon(icon) {
  const link = document.createElement('link');
  link.setAttribute('rel', 'prefetch');
  link.setAttribute('href', `https://js.verygoodvault.com/vgs-collect/icons/${icon}.svg`);
  document.head.appendChild(link);
}

export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function getContentLength(body) {
  try {
    if (!body) {
      return 0;
    } else if (isObject(body)) {
      return JSON.stringify(body).length;
    } else if (typeof body === 'string') {
      return body.length;
    }
    return 0;
  } catch (e) {
    return -1;
  }
}
